import { useNavigate, useSearchParams } from "react-router-dom";
import { adminlogin } from "../api/apiAdmin";
import LoadingOverlay from "../mui/LoadingOverlay";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addAmin } from "../redux/adminSlice";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../assets/logo.jpeg";
import vectorIcon from "../assets/Vector.png";
import frameIcon from "../assets/Frame.png";


const Login = () => {
  const [loading, setloading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const error = searchParams.get("error");
    if (error) {
      switch (error) {
        case "auth_failed":
          toast.error("SSO login failed. Please try again.");
          break;
        default:
          toast.error("Login failed. Please try again.");
      }
    }
  }, [searchParams, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    try {
      const response = await adminlogin(email, password);
      if (response && response.status === 200) {
        toast.success("Login Successfully");
        // console.log("response.data", response.data)
        dispatch(addAmin(response.data.admin));
        localStorage.setItem("lsh-token", response.data.token);
        navigate("/admin/UltimateHoldingCompany");
      } else if (response && response.status === 401) {
        toast.error("Invalid credentials");
      } else {
        toast.error("Failed to login");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to login");
    } finally {
      setloading(false);
    }
  };

  const handleAzureLogin = () => {
    localStorage.removeItem("lsh-token");
    setloading(true);
    window.location.href = `${import.meta.env.VITE_Backend_URL}/auth/sso/login`;
  };

  return (
    <>
      <div className="container-fluid vh-100 d-flex justify-content-center align-items-center bg-light">
        {/* Wrapper Box */}
        <div
          className="row g-0 rounded-1 shadow"
          style={{
            height: "80vh",
            width: "80vw",
            overflow: "hidden",
            backgroundColor: "white",
            boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)"
          }}
        >
          {/* Left Gradient Side */}
          <div
            className="col-md-6 d-none d-md-flex flex-column justify-content-evenly align-items-center"
            style={{
              background: "linear-gradient(135deg, rgb(0, 40, 85))",
              height: "100%",
              color: "white",
              textAlign: "center",
              padding: "2rem",
            }}
          >
            {/* Top Heading */}
            <div style={{ width: "100%", textAlign: "center" }}>
              <h2
                style={{
                  fontWeight: "bold",
                  fontSize: "1.75rem",
                  lineHeight: "1.4",
                  marginBottom: 0,
                }}
              >
                ORGANISATIONAL GROUP CHART <br /> SYSTEM
              </h2>
            </div>

            {/* Center Logo + Subheading */}
            <div className="d-flex flex-column justify-content-center align-items-center">
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "50%",
                  padding: "1rem",
                  marginBottom: "1rem",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                }}
              >
                <img
                  src={logo}
                  alt="Company Logo"
                  style={{ width: "80px", height: "auto" }}
                />
              </div>

              <h2
                style={{
                  fontWeight: "bold",
                  fontSize: "1.75rem",
                  lineHeight: "1.4",
                }}
              >
                LEI SHING HONG <br /> GROUP
              </h2>
            </div>
          </div>


          {/* Right Form Side */}
          <div
            className="col-md-6 d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: "#f4f4f9",
            }}
          >
            <div
              className="w-100 p-5"
              style={{
                maxWidth: "480px",
                borderRadius: "8px",
              }}
            >
              <h4 className="fw-bold text-center mb-4">LOGIN HERE</h4>
              <form onSubmit={handleSubmit}>
                {/* Email Input */}
                <div className="position-relative mb-3">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control ps-5"
                    placeholder="Email"
                    required
                    style={{ backgroundColor: "#f0f4f8", height: "50px" }}
                  />
                  <img
                    src={vectorIcon}
                    alt="icon"
                    className="position-absolute"
                    style={{
                      top: "50%",
                      left: "15px",
                      transform: "translateY(-50%)",
                      width: "1rem",
                    }}
                  />
                </div>

                {/* Password Input */}
                <div className="position-relative mb-4">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-control ps-5"
                    placeholder="Password"
                    required
                    style={{ backgroundColor: "#f0f4f8", height: "50px" }}
                  />
                  <img
                    src={frameIcon}
                    alt="icon"
                    className="position-absolute"
                    style={{
                      top: "50%",
                      left: "15px",
                      transform: "translateY(-50%)",
                      width: "1.2rem",
                    }}
                  />
                  <div
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                    className="position-absolute"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>

                {/* Buttons */}
                <button
                  className="btn w-100 py-2 rounded-3 mb-2"
                  style={{
                    backgroundColor: "transparent", // No background color by default
                    border: "2px solid #002a47", // Dark blue border for the outline
                    color: "#002a47", // Dark blue text color for the default state
                    boxShadow: "none", // No shadow by default
                    transition: "all 0.3s ease-in-out", // Smooth transition for hover effect
                    fontWeight: "bold",
                    // Slightly larger font size
                  }}
                  type="submit"
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#002a47"; // Change background to dark blue on hover
                    e.target.style.color = "white"; // Change text color to white on hover
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent"; // Return to transparent background on mouse leave
                    e.target.style.color = "#002a47"; // Return text color to dark blue on mouse leave
                  }}
                >
                  Sign in
                </button>
                <button
                  className="btn w-100 py-2 rounded-3"
                  style={{
                    backgroundColor: "transparent", // No background color by default
                    border: "2px solid #003e5c", // Lighter blue border for the outline
                    color: "#003e5c", // Lighter blue text color for the default state
                    boxShadow: "none", // No shadow by default
                    transition: "all 0.3s ease-in-out", // Smooth transition for hover effect
                    fontWeight: "bold", // Slightly larger font size
                  }}
                  type="button"
                  onClick={handleAzureLogin}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#003e5c"; // Change background to lighter blue on hover
                    e.target.style.color = "white"; // Change text color to white on hover
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent"; // Return to transparent background on mouse leave
                    e.target.style.color = "#003e5c"; // Return text color to lighter blue on mouse leave
                  }}
                >
                  Sign in via SSO
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <LoadingOverlay open={loading} />
    </>
  );
};

export default Login;
